import { DateTime } from 'luxon';

/**
 * Checks if the draw should apply to the next statement, so regenerating the old statement doesnt matter
 */
export const isDrawForNextStatement = (drawDate: Date, isPaymentDueOnFirstOfTheMonth: boolean) => {
  const now = DateTime.now();
  const isCurrentMonthBeforeGenerationDate = isPaymentDueOnFirstOfTheMonth ? now.day < 18 : true;
  return isCurrentMonthBeforeGenerationDate && DateTime.fromJSDate(drawDate).month === now.month;
};
